<div class="padding-vertical-25 padding-horizontal-10">
	<!-- title -->
	<div class="row border-bottom">
		<div class="col-10">
			<ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '30px' }"></ngx-skeleton-loader>
		</div>
	</div>
	<!-- body -->
	<div class="row padding-top-30">
		<div class="col-11 d-flex flex-direction-column border-bottom">
			<ngx-skeleton-loader [theme]="{ width: '25%', 'border-radius': '0', height: '18px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
		<div class="col-1"></div>
		<div class="col-11 d-flex flex-direction-column border-bottom">
			<ngx-skeleton-loader [theme]="{ width: '25%', 'border-radius': '0', height: '18px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
	</div>
	<div class="row padding-bottom-30">
		<div class="col-11 d-flex flex-direction-column border-bottom">
			<ngx-skeleton-loader [theme]="{ width: '25%', 'border-radius': '0', height: '18px' }"></ngx-skeleton-loader>
			<ngx-skeleton-loader [theme]="{ width: '50%', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
		</div>
	</div>
	<div class="row border-top" *ngFor="let row of GHOST_ROWS">
		<div class="col-6 d-flex align-items-center padding-top-15">
			<div class="margin-right-5">
				<ngx-skeleton-loader [theme]="{ width: '18px', 'border-radius': '0', height: '15px' }"></ngx-skeleton-loader>
			</div>
			<div>
				<ngx-skeleton-loader [theme]="{ width: '150px', 'border-radius': '0', height: '25px' }"></ngx-skeleton-loader>
			</div>
		</div>
	</div>
	<!-- buttons -->
	<div class="row justify-content-right">
		<div>
			<ngx-skeleton-loader [theme]="{ width: '100px', 'border-radius': '0', height: '40px' }"></ngx-skeleton-loader>
		</div>
		<div class="download-btn">
			<ngx-skeleton-loader [theme]="{ width: '150px', 'border-radius': '0', height: '40px' }"></ngx-skeleton-loader>
		</div>
	</div>
</div>
